import { createReducer, on } from '@ngrx/store';

import * as camerasActions from '@live/actions/live-cameras.actions';
import { ILiveCameraTab } from '@live/pages/live-camera-page/interfaces';

export interface State {
  selectedTab: ILiveCameraTab;
}

const initialState: State = {
  selectedTab: ILiveCameraTab.LIVE_STREAM
};

export const reducer = createReducer(
  initialState,
  on(camerasActions.setCameraTab, (state, { tab }) => {
    return {
      ...state,
      selectedTab: tab
    };
  })
);
